
export {
	ProgressBar,
	SearchResultsMgr,
	PlayerMgr,
	PlayListMgr,
	SearchGamesMgr,
	SearchOpsMgr,
	SetupMgr,
	TabMgr,
	start,
	convertTouchLogEntry,
	debug,
	get_game,
	get_match,
	hide_columns_for_wr
};

import 'jquery-jeditable';

import '../vendor/easyModal.js/jquery.easyModal.js';
import {e} from './utils.js';
import {load_ytplayer} from './ytplayer.js';
import {PlayerManager} from './playermgr.js';
import {SetupManager} from './setupmgr.js';
import {SearchGamesManager} from './searchgamesmgr.js';
import {SearchOptionsManager} from './searchoptionsmgr.js';
import {SearchResultsManager} from './searchresultsmgr.js';
import {PlayListManager} from './playlistmgr.js';
import {TabManager} from './tabmgr.js';
import {Progress} from './progress.js';
import {Utils} from '../lib/utils.js';

// local CSS
import '../../css/vidix/main.less';

// Extracted global values from HTML
export const state = {
	debug: false,
	teams: [],
	matches: [],
	games: [],
	videos: {},
	playlists: [],
	solouid: '',
	owner: false,
	wr_editor: false,
	yt_auth: false,
	touch: false,
	playlistonly: 0
};

// ---------------------------
// Retrieval Methods
// ---------------------------

function get_match(match_id) {

	for (var i = 0; i < state.matches.length; i++) {
		if (! state.matches[i]){
			continue;
		}

		if (state.matches[i].id == match_id){
			return (state.matches[i]);
		}
	}

	return (null);
}

function get_game(game_id) {

	for (var i = 0; i < state.games.length; i++) {
		if (! state.games[i]) {
			continue;
		}

		if (state.games[i].id == game_id){
			return (state.games[i]);
		}
	}

	return (null);
}

// ---------------------------
// Convert Touch Log Entry
// ---------------------------


function convertTouchLogEntry(entry, players) {
	// Converts a Touch log entry into a Live/123-style entry for WebReports use
	var newEntry = ['LogEntry'];

	// date
	newEntry.push(entry.timestamp);
	// rotation
	newEntry.push(null);
	// serving
	newEntry.push(null);
	// team
	newEntry.push('us');
	// playernum
	newEntry.push(entry.playernum);
	// name
	var name = null;
	for (var i=0; i < players.length; i++) {
		if (players[i].num === entry.playernum) {
			name = players[i].name;
			break;
		}
	}
	newEntry.push(name);
	// action
	var action = null;
	for (var j=0; j < entry.action.tags.length; j++) {
		if (entry.action.tags[j] === 'earned' ||
			entry.action.tags[j] === 'errors' ||
			entry.action.tags[j] === 'faults' ||
			entry.action.tags[j] === 'in_rally' ||
			entry.action.tags[j] === 'touch'
		) {
			action = entry.action.tags[j];
			break;
		}
	}
	newEntry.push(action);
	// code
	var code = entry.action.code;
	if (action === 'errors') {
		if (code === 'tip')  { code = 'tipe'; }
		if (code === 'dump') { code = 'dumpe'; }
		if (code === 'dbh')  { code = 'dbhe'; }
		if (code === 'blck') { code = 'blcke'; }
	}
	newEntry.push(code);
	// point
	newEntry.push(null);
	// points
	newEntry.push(null);
	// server
	newEntry.push(null);
	// setter
	newEntry.push(null);
	// asstnum
	newEntry.push(null);
	// asstname
	newEntry.push(null);
	// lineup
	newEntry.push(null);

	return newEntry;
}


// ---------------------------
// Debug
// ---------------------------

function debug(s, level) {

	if (! state.debug) {
		return;
	}

	if (level === undefined) {
		level = 0;
	}

	if (s === undefined) {
		s = "";
	}

	e("debug").innerHTML += Array(level+1).join("   ") + s + "<br>";
	e("debug").scrollTop = e("debug").scrollHeight;
}


// ---------------------------
// Inits
// ---------------------------

var ProgressBar;

var PlayerMgr;
var PlayListMgr;
var SearchGamesMgr;
var SearchOpsMgr;
var SearchResultsMgr;
var SetupMgr;
var TabMgr;

function start() {

	// check for flex support
	if ($('body').get(0).style.flex === undefined){
		$('body').hide();
		window.setTimeout(function(){
			alert('Browser does not support Flexbox. Please upgrade your browser to use SoloStats Video.');
		}, 100);
		return;
	}

	$("#title_bar").hide();
	$("#initialization").show();

	return $.ajax({
		url: "/vidix/init",
		type: "get",
		dataType: "json",
		data: {
			uid: Utils.getParameterByName('uid'),
			wr: Utils.getParameterByName('wr'),
		},
	})
		.then((rsp) => {

			// process teams
			let teams = [];
			for (let i=0; i < rsp.json_teams.length; i++) {
				let team = rsp.json_teams[i];

				teams.push({
					"id": team.app_data.id,
					"name": team.app_data.name,
					"players": team.app_data.players,
				});
			}

			state.teams        = teams;
			state.matches      = rsp.json_matches;
			state.games        = rsp.json_games;
			state.videos       = rsp.json_videos;
			state.playlists    = rsp.json_playlists;
			state.solouid      = rsp.solo_uid;
			state.owner        = rsp.owner;
			state.wr_editor    = !!rsp.wr_editor;
			state.yt_auth      = rsp.ytauth;
			state.touch        = rsp.touch;
			state.playlistonly = parseInt(Utils.getParameterByName('playlist')) || 0;
			state.starting_tab = Utils.getParameterByName('tab') || "games";

			inits();
		}, () => {
			alert('There was an error initializing your data. Please contact support@rotate123.com for assistance.');
		});
}

function inits() {

	$("#initialization").hide();
	$("#title_bar").show();
	$("#main_wrapper").show();

	// set body height to fix vh bug on mobile
	$("body").css("height", window.innerHeight + "px");
	window.addEventListener('resize', function(){
		$("body").css("height", window.innerHeight + "px");
	});

	// Load the progress bar
	ProgressBar = Progress(240, 750, Math.min(window.innerWidth*0.75, 500)); //x, y, w
	ProgressBar.set_text("Calculating results...");
	e("mybody").appendChild(ProgressBar);

	load_ytplayer("YUGRnXhc2yM");

	PlayerMgr        = new PlayerManager();
	SetupMgr         = new SetupManager();
	SearchGamesMgr   = new SearchGamesManager();
	SearchOpsMgr     = new SearchOptionsManager();
	SearchResultsMgr = new SearchResultsManager();
	PlayListMgr      = new PlayListManager();
	TabMgr           = new TabManager();

	// Transform touch data
	if (state.touch) {
		for (let i=0, ilen=state.matches.length; i < ilen; i++) {
			state.matches[i].team_id = state.matches[i].teamId;
			state.matches[i].opponent = state.matches[i].eventName || '';
			state.matches[i].venue = state.matches[i].eventLocation || '';
		}
		for (let i=0, ilen=state.games.length; i < ilen; i++) {
			state.games[i].match_id = state.games[i].matchEventId;
			// Convert log entry format
			var newlog = [];
			var players = [];
			for (var y=0, ylen=state.teams.length; y < ylen; y++) {
				if (state.teams[y].id === state.games[i].teamId) {
					players = state.teams[y].players;
				}
			}
			for (var z=0, zlen=state.games[i].log.length; z < zlen; z++) {
				var newEntry = convertTouchLogEntry(state.games[i].log[z], players);
				newlog.push(newEntry);
			}
			state.games[i].oldlog = state.games[i].log;
			state.games[i].log = newlog;
		}
	}

	// Load Games
	SearchGamesMgr.load_team_selector();
	SearchGamesMgr.load_games_table();

	// Load filters
	SearchOpsMgr.load_player_column();
	if (state.touch) {
		SearchOpsMgr.load_action_column("touch");
		SearchOpsMgr.load_action_column("attack");
		SearchOpsMgr.load_action_column("receive");
		SearchOpsMgr.load_action_column("defend");
		SearchOpsMgr.load_action_column("set");
		SearchOpsMgr.load_action_column("faults");
	} else {
		SearchOpsMgr.load_rotation_column();
		SearchOpsMgr.load_action_column("in_rally");
		SearchOpsMgr.load_action_column("earned");
		SearchOpsMgr.load_action_column("errors");
		SearchOpsMgr.load_action_column("faults");
	}

	// Check all filter options
	SearchOpsMgr.check_all_players();
	if (state.touch) {
		SearchOpsMgr.check_all_actions("touch");
		SearchOpsMgr.check_all_actions("attack");
		SearchOpsMgr.check_all_actions("receive");
		SearchOpsMgr.check_all_actions("defend");
		SearchOpsMgr.check_all_actions("set");
		SearchOpsMgr.check_all_actions("faults");
	} else {
		SearchOpsMgr.check_all_rotations();
		SearchOpsMgr.check_all_actions("in_rally");
		SearchOpsMgr.check_all_actions("earned");
		SearchOpsMgr.check_all_actions("errors");
		SearchOpsMgr.check_all_actions("faults");
	}

	// Load the game in the Setup page
	SetupMgr.load_game_selector();

	// Load playlists
	PlayListMgr.load_playlist_selector();

	// Start on specified tab, or Games if not specified
	if (state.playlistonly > 0) {
		$('.tab_panel').hide();
		TabMgr.show("playlists");
		$('#playlist_page').css('height', '100%');
	} else {
		TabMgr.show(state.starting_tab);
	}

	if (state.wr_editor){
		// Page is being loaded as WebReports editor; load to game's setup page and hide all non-editing-related features
		TabMgr.show("setup");
		$('#player_div').remove();
		$('#title_bar').hide();
		$('#tab_bar').hide();
		$('#setup_video_cmds').hide();
		$('#setup_page').hide();
		$('#playlist_page').hide();
		hide_columns_for_wr();
		$('#selGame').attr('disabled', true);
	}
}

function hide_columns_for_wr() {
	$('#setup_page').fadeIn(300).css('height', 500);
	$('#novideo').hide();
	$('.video_cell').hide().next().hide();
	$('.offset_cell').hide().next().hide();
	$('.vstate_cell').hide().next().hide();
	$('#setup_page').css('width', '100%').css('height', '100%');
	$('#setup_log_column').css('width', 500).css('height', 470);
	$('#setup_log_table .data_table').css('width', 493);
	$('.data_table_rows').css('width', 493);
	$('.data_table_row').css('width', 479);
	$('#setup_log_table .data_table_header').children().eq(5).css('margin-right', 14);
	$('#tabs_wrapper').css('min-height', '100%');
}
